// src/components/admin/page-sections/ColumnsSection.js
import React from 'react';
import parse from 'html-react-parser';
import '../../../styles/sections.css';

const ColumnsSection = ({ content }) => {
  const columns = content?.columns || [];
  const columnGap = content?.columnGap || '1rem';
  const columnsAlignment = content?.columnsAlignment || 'stretch';
  const stackAt = content?.stackAt || 'sm';
  
  // Determine responsive classes based on stack-at breakpoint
  const getContainerClasses = () => {
    switch (stackAt) {
      case 'none':
        return 'flex';
      case 'xs':
        return 'flex flex-col xs:flex-row';
      case 'sm':
        return 'flex flex-col sm:flex-row';
      case 'md':
        return 'flex flex-col md:flex-row';
      case 'lg':
        return 'flex flex-col lg:flex-row';
      case 'xl':
        return 'flex flex-col xl:flex-row';
      default:
        return 'flex flex-col sm:flex-row';
    }
  };
  
  // If no columns, show a placeholder
  if (columns.length === 0) {
    return <div className="py-4 text-center text-gray-500">No columns defined</div>;
  }
  
  return (
    <div 
      className={getContainerClasses()}
      style={{ 
        gap: columnGap,
        alignItems: columnsAlignment
      }}
    >
      {columns.map((column, index) => {
        // Determine flex or width based on column.width
        let columnStyle = {};
        
        if (column.width) {
          if (column.width.includes('fr')) {
            // Handle flex-grow with 'fr' values
            const flexGrow = parseInt(column.width);
            columnStyle.flex = `${flexGrow} 1 0%`;
          } else {
            // Handle percentage or fixed widths
            columnStyle.width = column.width;
            columnStyle.flexShrink = 0;
          }
        } else {
          // Default equal width
          columnStyle.flex = '1 1 0%';
        }
        
        // Add other custom styles
        if (column.backgroundColor) columnStyle.backgroundColor = column.backgroundColor;
        if (column.textColor) columnStyle.color = column.textColor;
        if (column.padding) columnStyle.padding = column.padding;
        
        // Column alignment
        const textAlignClass = column.alignment ? `text-${column.alignment}` : '';
        
        return (
          <div 
            key={index} 
            className={`mb-4 sm:mb-0 ${textAlignClass}`}
            style={columnStyle}
          >
            {column.title && <h3 className="text-xl font-semibold mb-2">{column.title}</h3>}
            
            {column.imageUrl && (
              <div className="mb-4">
                <img 
                  src={column.imageUrl} 
                  alt={column.title || `Column ${index + 1}`} 
                  className="w-full h-auto rounded"
                />
              </div>
            )}
            
            {column.content && (
              <div className="prose">
                {column.content.includes('<') ? parse(column.content) : <p>{column.content}</p>}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default ColumnsSection;






// // src/components/sections/ColumnsSection.js
// import React from 'react';
// import parse from 'html-react-parser';

// const ColumnsSection = ({ content }) => {
//   const { columns = [] } = content;

//   if (!columns.length) return null;

//   return (
//     <div className="py-12">
//       <div className={`grid grid-cols-1 md:grid-cols-${Math.min(columns.length, 3)} gap-8`}>
//         {columns.map((column, index) => (
//           <div key={index} className="flex flex-col">
//             {column.imageUrl && (
//               <img 
//                 src={column.imageUrl} 
//                 alt={column.title || `Column ${index + 1}`} 
//                 className="w-full h-48 object-cover rounded-lg mb-4"
//               />
//             )}
//             {column.title && <h3 className="text-xl font-bold mb-2">{column.title}</h3>}
//             {column.content && (
//               <div className="prose">
//                 {typeof column.content === 'string' && column.content.includes('<') 
//                   ? parse(column.content)
//                   : <p>{column.content}</p>
//                 }
//               </div>
//             )}
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default ColumnsSection;